<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter" title="Part 1: Muddled Mythologies">
<p class="pno" id="pt1"><span class="right_1" epub:type="pagebreak" id="page_22" title="22"><span class="right_1" epub:type="pagebreak" id="page_23" title="23"><a href="#/text/Contents#rpt1">PART 1</a></span></span></p>
<p class="ptitle"><a href="#/text/Contents#rpt1">Muddled Mythologies</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part01.vue?7ab6cebd